if (!customElements.get('volt-store-hours')) {
  customElements.define('volt-store-hours', class extends HTMLElement {
    connectedCallback() { this.updateStatus(); this.timer = setInterval(() => this.updateStatus(), 60000); }
    disconnectedCallback() { clearInterval(this.timer); }
    updateStatus(now = new Date()) {
      try {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: this.dataset.timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now).map(p => [p.type, p.value]));
        const local = new Date(`${parts.year}-${parts.month}-${parts.day}T12:00:00Z`);
        const minute = Number(parts.hour) * 60 + Number(parts.minute);
        const closures = new Set(this.dataset.closures.split(/\s+/).filter(Boolean));
        const rows = [...this.querySelectorAll('[data-days]')].map(row => {
          const times = row.dataset.hours.match(/(\d{1,2}):(\d{2})\s*[–—-]\s*(\d{1,2}):(\d{2})/);
          if (!times) return null;
          const start = Number(times[1]) * 60 + Number(times[2]), end = Number(times[3]) * 60 + Number(times[4]);
          if (start >= end || end > 1440 || Number(times[2]) > 59 || Number(times[4]) > 59) return null;
          return { days: row.dataset.days.split(',').map(Number), start, end, from: `${times[1].padStart(2, '0')}:${times[2]}`, until: `${times[3].padStart(2, '0')}:${times[4]}` };
        }).filter(Boolean);
        let open = null, next = null;
        for (let offset = 0; offset < 370; offset++) {
          const day = new Date(local); day.setUTCDate(day.getUTCDate() + offset);
          if (closures.has(day.toISOString().slice(0, 10))) continue;
          const intervals = rows.filter(r => r.days.includes(day.getUTCDay() || 7)).sort((a, b) => a.start - b.start);
          if (offset === 0) open = intervals.find(r => minute >= r.start && minute < r.end);
          const upcoming = intervals.find(r => offset > 0 || minute < r.start);
          if (open || upcoming) { if (upcoming) next = { ...upcoming, offset, day }; break; }
        }
        const status = this.querySelector('.vs-status'); status.classList.toggle('vs-open', Boolean(open));
        this.querySelector('.vs-state').textContent = open ? this.dataset.open : this.dataset.closed;
        let text = '';
        if (open) text = this.dataset.closes.replace('__TIME__', open.until);
        else if (next) {
          const template = next.offset === 0 ? this.dataset.today : next.offset === 1 ? this.dataset.tomorrow : this.dataset.next;
          const dayName = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { weekday: 'long', timeZone: 'UTC' }).format(next.day);
          text = template.replace('__TIME__', next.from).replace('__DAY__', dayName);
        }
        this.querySelector('.vs-next').textContent = text; status.hidden = false; this.querySelector('.vs-fallback').hidden = true;
      } catch (_) { this.querySelector('.vs-fallback').hidden = false; }
    }
  });
}
const setFooterMenus = () => { document.querySelectorAll('.vf-menu').forEach(menu => { menu.open = window.matchMedia('(min-width:768px)').matches; }); };
setFooterMenus();
window.matchMedia('(min-width:768px)').addEventListener('change', setFooterMenus);
document.addEventListener('shopify:section:load', setFooterMenus);
const updateFooterReviews = async () => {
  const badges = [...document.querySelectorAll('.vf-reviews[data-review-feed]')];
  const feed = badges[0]?.dataset.reviewFeed;
  if (!feed) return;
  try {
    const response = await fetch(feed);
    if (!response.ok) return;
    const { summary } = await response.json();
    if (!Number.isFinite(summary?.averageRating) || !Number.isFinite(summary?.totalReviews)) return;
    badges.forEach(badge => { badge.querySelector('.vf-review-copy').textContent = badge.dataset.reviewTemplate.replace('__RATING__', summary.averageRating.toFixed(2)).replace('__COUNT__', summary.totalReviews); });
  } catch (_) {}
};
updateFooterReviews();
document.addEventListener('shopify:section:load', updateFooterReviews);
